export default "__VITE_ASSET__8cdd1a5e__"